/* SZ size calculator — height/weight -> recommended size.
   Rules are evaluated top to bottom, first match wins. */
const SZ_SIZE_GRIDS = {
  /* 1 — Штани / Зіпки / Футболки — стандартні розміри */
  standard: {
    height: [150, 202],
    weight: [40, 120],
    scale: ['S', 'M', 'L', 'XL', 'XXL'],
    rules: [
      [150, 202, 40, 60, 'S'],
      [150, 180, 60, 63, 'S'],
      [150, 175, 63, 66, 'S'],

      [180, 202, 60, 63, 'M'],
      [175, 202, 63, 66, 'M'],
      [150, 202, 66, 69, 'M'],
      [150, 195, 69, 72, 'M'],
      [150, 187, 72, 75, 'M'],
      [150, 180, 75, 78, 'M'],
      [150, 175, 78, 81, 'M'],

      [195, 202, 69, 72, 'L'],
      [187, 202, 72, 75, 'L'],
      [180, 202, 75, 78, 'L'],
      [175, 202, 78, 81, 'L'],
      [150, 202, 81, 84, 'L'],
      [150, 185, 84, 87, 'L'],
      [150, 180, 87, 90, 'L'],
      [150, 170, 90, 93, 'L'],

      [185, 202, 84, 87, 'XL'],
      [180, 202, 87, 90, 'XL'],
      [170, 195, 90, 93, 'XL'],
      [150, 190, 93, 96, 'XL'],
      [150, 185, 96, 99, 'XL'],

      [195, 202, 90, 93, 'XXL'],
      [190, 202, 93, 96, 'XXL'],
      [185, 202, 96, 99, 'XXL'],
      [150, 202, 99, 120, 'XXL']
    ]
  },

  /* 2 — Здвоєні розміри */
  double: {
    height: [150, 202],
    weight: [40, 120],
    scale: ['XS/S', 'S/M', 'L/XL', 'XXL'],
    rules: [
      [150, 187, 40, 51, 'XS/S'],
      [150, 185, 51, 57, 'XS/S'],
      [150, 180, 54, 60, 'XS/S'],
      [150, 170, 60, 63, 'XS/S'],

      [187, 202, 42, 51, 'S/M'],
      [185, 202, 51, 57, 'S/M'],
      [180, 202, 57, 60, 'S/M'],
      [170, 202, 60, 63, 'S/M'],
      [150, 202, 63, 66, 'S/M'],
      [150, 195, 66, 69, 'S/M'],
      [150, 190, 69, 75, 'S/M'],
      [150, 185, 75, 78, 'S/M'],
      [150, 175, 78, 81, 'S/M'],

      [195, 202, 66, 69, 'L/XL'],
      [190, 202, 69, 75, 'L/XL'],
      [185, 202, 75, 78, 'L/XL'],
      [175, 202, 78, 81, 'L/XL'],
      [150, 202, 81, 87, 'L/XL'],
      [150, 195, 87, 90, 'L/XL'],
      [150, 190, 90, 93, 'L/XL'],
      [150, 187, 93, 96, 'L/XL'],
      [150, 170, 96, 99, 'L/XL'],

      [195, 202, 87, 90, 'XXL'],
      [190, 202, 90, 93, 'XXL'],
      [187, 202, 93, 96, 'XXL'],
      [170, 202, 96, 99, 'XXL'],
      [150, 202, 99, 120, 'XXL']
    ]
  },

  /* 3 — Худі / Лонги — маломірить */
  undersize: {
    height: [150, 202],
    weight: [40, 120],
    scale: ['S', 'M', 'L', 'XL', 'XXL'],
    rules: [
      [150, 202, 40, 54, 'S'],
      [150, 170, 54, 60, 'S'],

      [170, 202, 54, 60, 'M'],
      [150, 202, 60, 66, 'M'],
      [150, 180, 66, 69, 'M'],
      [150, 170, 69, 72, 'M'],

      [180, 202, 66, 69, 'L'],
      [170, 202, 69, 72, 'L'],
      [150, 202, 72, 78, 'L'],
      [150, 190, 78, 81, 'L'],
      [150, 180, 81, 84, 'L'],
      [150, 175, 84, 87, 'L'],

      [190, 202, 78, 81, 'XL'],
      [180, 202, 81, 84, 'XL'],
      [175, 202, 84, 87, 'XL'],
      [150, 202, 87, 90, 'XL'],
      [150, 195, 90, 93, 'XL'],
      [150, 190, 93, 96, 'XL'],

      [195, 202, 90, 93, 'XXL'],
      [190, 202, 93, 96, 'XXL'],
      [150, 202, 96, 120, 'XXL']
    ]
  },

  /* 4 — Куртки / Жилетки — товари з XS */
  xs: {
    height: [150, 202],
    weight: [40, 120],
    scale: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    rules: [
      [150, 180, 40, 51, 'XS'],
      [150, 170, 51, 54, 'XS'],
      [150, 165, 54, 57, 'XS'],

      [180, 202, 42, 51, 'S'],
      [170, 202, 51, 54, 'S'],
      [165, 202, 54, 57, 'S'],
      [150, 202, 57, 60, 'S'],
      [150, 180, 60, 63, 'S'],
      [150, 175, 63, 66, 'S'],
      [150, 165, 66, 69, 'S'],

      [180, 202, 60, 63, 'M'],
      [175, 202, 63, 66, 'M'],
      [165, 202, 66, 69, 'M'],
      [150, 195, 69, 72, 'M'],
      [150, 187, 72, 75, 'M'],
      [150, 180, 75, 78, 'M'],
      [150, 175, 78, 81, 'M'],

      [195, 202, 69, 72, 'L'],
      [187, 202, 72, 75, 'L'],
      [180, 202, 75, 78, 'L'],
      [175, 202, 78, 81, 'L'],
      [150, 202, 81, 84, 'L'],
      [150, 185, 84, 87, 'L'],
      [150, 180, 87, 90, 'L'],
      [150, 170, 90, 93, 'L'],

      [185, 202, 84, 87, 'XL'],
      [180, 202, 87, 90, 'XL'],
      [170, 195, 90, 93, 'XL'],
      [150, 190, 93, 96, 'XL'],
      [150, 185, 96, 99, 'XL'],

      [195, 202, 90, 93, 'XXL'],
      [190, 202, 93, 96, 'XXL'],
      [185, 202, 96, 99, 'XXL'],
      [150, 202, 99, 120, 'XXL']
    ]
  }
};

/* Store spellings -> the size names the grids speak. */
const SZ_SIZE_CANONICAL = {
  '3XS': 'XXXS', XXXS: 'XXXS',
  '2XS': 'XXS', XXS: 'XXS',
  XS: 'XS', S: 'S', M: 'M', L: 'L', XL: 'XL',
  '2XL': 'XXL', XXL: 'XXL',
  '3XL': 'XXXL', XXXL: 'XXXL',
  '4XL': '4XL', XXXXL: '4XL',
  'XS/S': 'XS/S', 'S/M': 'S/M', 'M/L': 'M/L', 'L/XL': 'L/XL',
  'XL/XXL': 'XL/XXL', 'XL/2XL': 'XL/XXL'
};

/* Accepted spellings of a size in the variant option values. */
const SZ_SIZE_ALIASES = {
  XS: ['XS'],
  S: ['S'],
  M: ['M'],
  L: ['L'],
  XL: ['XL'],
  XXL: ['XXL', '2XL'],
  XXXL: ['XXXL', '3XL'],
  '4XL': ['4XL', 'XXXXL'],
  'XS/S': ['XS/S', 'XS-S', 'XSS', 'XS / S'],
  'S/M': ['S/M', 'S-M', 'SM', 'S / M'],
  'L/XL': ['L/XL', 'L-XL', 'LXL', 'L / XL']
};

/* "2XL", "m", "M (48-50)" -> "XXL", "M", "M". Returns null for anything
   that is not a letter size (numeric jeans sizes, ring sizes, ONE SIZE). */
function szCanonicalSize(value) {
  const cleaned = String(value || '')
    .toUpperCase()
    .replace(/\s+/g, '')
    .replace(/-/g, '/')
    .replace(/\(.*$/, '');
  return SZ_SIZE_CANONICAL[cleaned] || null;
}

function szParseSizeList(raw) {
  if (!raw) return [];
  const sizes = [];
  for (const part of String(raw).split('|')) {
    const size = szCanonicalSize(part);
    if (size && !sizes.includes(size)) sizes.push(size);
  }
  return sizes;
}

/* Height/weight the form accepts; anything inside is clamped into the
   grid's own range so a valid entry never dead-ends on an error. */
const SZ_INPUT_HEIGHT = [140, 210];
const SZ_INPUT_WEIGHT = [35, 150];

/* US units: the grids stay in cm / kg, US input is converted on the way in. */
const SZ_CM_PER_IN = 2.54;
const SZ_KG_PER_LB = 0.45359237;

function szUsUnits() {
  return document.documentElement.dataset.szUnits === 'us';
}

class SzSizeCalculator extends HTMLElement {
  connectedCallback() {
    this.grid = SZ_SIZE_GRIDS[this.dataset.grid] ? this.dataset.grid : 'standard';
    this.form = this.querySelector('[data-sc-form]');
    this.heightInput = this.querySelector('[data-sc-height]');
    this.weightInput = this.querySelector('[data-sc-weight]');
    this.heightFtInput = this.querySelector('[data-sc-height-ft]');
    this.heightInInput = this.querySelector('[data-sc-height-in]');
    this.weightLbInput = this.querySelector('[data-sc-weight-lb]');
    this.result = this.querySelector('[data-sc-result]');
    this.resultSize = this.querySelector('[data-sc-size]');
    this.resultNote = this.querySelector('[data-sc-note]');
    this.error = this.querySelector('[data-sc-error]');
    this.apply = this.querySelector('[data-sc-apply]');

    this.productSizes = szParseSizeList(this.dataset.sizes);
    this.inStockSizes = szParseSizeList(this.dataset.sizesInStock);

    if (!this.form) return;
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.calculate();
    });
    if (this.apply) this.apply.addEventListener('click', () => this.selectVariant());

    /* Switching units carries what was already typed over to the other fields. */
    this.onUnits = (event) => this.carryOver(event.detail && event.detail.units);
    document.addEventListener('sz:units', this.onUnits);
  }

  disconnectedCallback() {
    if (this.onUnits) document.removeEventListener('sz:units', this.onUnits);
  }

  /* Height in cm and weight in kg, whichever units the visitor typed in. */
  readMeasurements() {
    if (szUsUnits() && this.heightFtInput && this.weightLbInput) {
      const ft = parseFloat(this.heightFtInput.value);
      const inches = parseFloat(this.heightInInput && this.heightInInput.value);
      const lb = parseFloat(this.weightLbInput.value);
      const totalIn = Number.isFinite(ft) ? ft * 12 + (Number.isFinite(inches) ? inches : 0) : NaN;
      /* Rules are in whole cm / kg — round so 5'11" / 170 lb lands where 180 cm / 77 kg does. */
      return { height: Math.round(totalIn * SZ_CM_PER_IN), weight: Math.round(lb * SZ_KG_PER_LB) };
    }
    return {
      height: parseFloat(this.heightInput.value),
      weight: parseFloat(this.weightInput.value)
    };
  }

  carryOver(units) {
    if (!this.heightFtInput || !this.weightLbInput) return;
    if (units === 'us') {
      const cm = parseFloat(this.heightInput.value);
      const kg = parseFloat(this.weightInput.value);
      if (Number.isFinite(cm)) {
        const totalIn = Math.round(cm / SZ_CM_PER_IN);
        this.heightFtInput.value = Math.floor(totalIn / 12);
        if (this.heightInInput) this.heightInInput.value = totalIn % 12;
      }
      if (Number.isFinite(kg)) this.weightLbInput.value = Math.round(kg / SZ_KG_PER_LB);
    } else if (units === 'metric') {
      const ft = parseFloat(this.heightFtInput.value);
      const inches = parseFloat(this.heightInInput && this.heightInInput.value);
      const lb = parseFloat(this.weightLbInput.value);
      if (Number.isFinite(ft)) {
        const totalIn = ft * 12 + (Number.isFinite(inches) ? inches : 0);
        this.heightInput.value = Math.round(totalIn * SZ_CM_PER_IN);
      }
      if (Number.isFinite(lb)) this.weightInput.value = Math.round(lb * SZ_KG_PER_LB);
    }
  }

  calculate() {
    const { height, weight } = this.readMeasurements();

    if (!Number.isFinite(height) || !Number.isFinite(weight)) {
      this.showError(this.dataset.errorEmpty);
      return;
    }
    if (
      height < SZ_INPUT_HEIGHT[0] || height > SZ_INPUT_HEIGHT[1] ||
      weight < SZ_INPUT_WEIGHT[0] || weight > SZ_INPUT_WEIGHT[1]
    ) {
      this.showError(this.dataset.errorRange);
      return;
    }

    const size = this.match(height, weight);
    if (!size) {
      this.showError(this.dataset.errorRange);
      return;
    }

    const outcome = this.resolve(size);
    if (outcome.status === 'too-large') {
      /* Never round down to something the customer cannot get into — say
         the model does not go that far instead. */
      this.showError(this.dataset.noteTooLarge);
      return;
    }
    this.showResult(outcome);
  }

  match(height, weight) {
    const config = SZ_SIZE_GRIDS[this.grid];
    const h = Math.min(Math.max(height, config.height[0]), config.height[1]);
    const w = Math.min(Math.max(weight, config.weight[0]), config.weight[1]);

    for (const [hMin, hMax, wMin, wMax, size] of config.rules) {
      if (h >= hMin && h <= hMax && w >= wMin && w <= wMax) return size;
    }

    /* Grids leave a couple of hairline gaps at the boundaries — fall back
       to the closest rule instead of refusing to answer. */
    let best = null;
    let bestDistance = Infinity;
    for (const [hMin, hMax, wMin, wMax, size] of config.rules) {
      const dh = Math.max(hMin - h, h - hMax, 0);
      const dw = Math.max(wMin - w, w - wMax, 0);
      const distance = dh * dh + dw * dw;
      if (distance < bestDistance) {
        bestDistance = distance;
        best = size;
      }
    }
    return best;
  }

  showError(message) {
    if (this.result) this.result.hidden = true;
    if (this.error) {
      this.error.textContent = message || '';
      this.error.hidden = false;
    }
  }

  showResult(outcome) {
    if (this.error) this.error.hidden = true;
    if (!this.result) return;

    const size = outcome.size;
    this.currentSize = size;
    this.resultSize.textContent = size;
    this.result.hidden = false;

    const input = this.findOptionInput(size);
    if (this.apply) {
      this.apply.hidden = !input;
      this.apply.textContent = (this.dataset.applyLabel || '').replace('%s', size);
    }
    if (this.resultNote) {
      const soldOut = this.inStockSizes.length > 0 && !this.inStockSizes.includes(size);
      let note;
      if (!input || soldOut) {
        note = this.dataset.noteMissing;
      } else if (outcome.status === 'smallest') {
        note = this.dataset.noteSmallest;
      } else {
        note = this.dataset.noteFit;
      }
      this.resultNote.textContent = note || '';
    }
  }

  /* A grid spans S..XXL, but this product may only run S..L (or XS..L on a
     women's cut). Rounding is only safe when it cannot leave the customer in
     something too tight:
       too-large — the model stops below their size; refuse rather than promise
       smallest  — their size is under the run; the smallest one is only roomy
       rounded   — a hole inside the run; step up to the next size offered */
  resolve(size) {
    const scale = SZ_SIZE_GRIDS[this.grid].scale;
    const wanted = scale.indexOf(size);
    const offered = this.productSizes
      .map((value) => scale.indexOf(value))
      .filter((index) => index >= 0)
      .sort((a, b) => a - b);

    if (wanted < 0 || !offered.length || offered.includes(wanted)) {
      return { size, status: 'exact' };
    }
    if (wanted > offered[offered.length - 1]) {
      return { size, status: 'too-large' };
    }
    if (wanted < offered[0]) {
      return { size: scale[offered[0]], status: 'smallest' };
    }
    return { size: scale[offered.find((index) => index > wanted)], status: 'rounded' };
  }

  findOptionInput(size) {
    const formId = this.dataset.productForm;
    if (!formId) return null;

    const wanted = (SZ_SIZE_ALIASES[size] || [size]).map((value) =>
      value.replace(/\s+/g, '').toUpperCase()
    );
    const inputs = document.querySelectorAll(`input[type="radio"][form="${CSS.escape(formId)}"]`);

    return (
      Array.from(inputs).find((input) => {
        const value = (input.value || '').replace(/\s+/g, '').toUpperCase();
        /* "M" also matches option values like "M (48-50)". */
        return wanted.some((candidate) => value === candidate || value.startsWith(candidate + '('));
      }) || null
    );
  }

  selectVariant() {
    const input = this.findOptionInput(this.currentSize);
    if (!input) return;

    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if (label) {
      label.click();
    } else {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.closest('modal-dialog')?.hide?.();
  }
}

if (!customElements.get('sz-size-calculator')) {
  customElements.define('sz-size-calculator', SzSizeCalculator);
}
